import { createServerFn } from "@tanstack/react-start";
import {
  loadComparison,
  loadCompareDimensions,
  buildComparePairs,
  buildPublishedComparePairs,
  findRivals,
  findRivalsForModel,
} from "@/lib/compare.server";

export const getComparison = createServerFn({ method: "GET" })
  .inputValidator((data: { pair: string }) => data)
  .handler(async ({ data }) => {
    const { a, b } = await loadComparison(data.pair);
    if (!a || !b) return { a: null, b: null, rivals: [], rivalsB: [], dimsA: null, dimsB: null };
    const [rivals, rivalsB, dimsA, dimsB] = await Promise.all([
      findRivals(a.makeSlug, a.modelSlug, a.vehicleClass, 12),
      findRivals(b.makeSlug, b.modelSlug, b.vehicleClass, 12),
      loadCompareDimensions(a.makeSlug, a.modelSlug),
      loadCompareDimensions(b.makeSlug, b.modelSlug),
    ]);
    return {
      a,
      b,
      dimsA,
      dimsB,
      rivals: rivals.filter(
        (r) =>
          r.slug !==
          `${a.makeSlug}-${a.modelSlug}-vs-${b.makeSlug}-${b.modelSlug}` &&
          r.slug !==
          `${b.makeSlug}-${b.modelSlug}-vs-${a.makeSlug}-${a.modelSlug}`,
      ),
      rivalsB: rivalsB.filter(
        (r) =>
          r.slug !==
          `${a.makeSlug}-${a.modelSlug}-vs-${b.makeSlug}-${b.modelSlug}` &&
          r.slug !==
          `${b.makeSlug}-${b.modelSlug}-vs-${a.makeSlug}-${a.modelSlug}`,
      ),
    };
  });


export const getComparePairs = createServerFn({ method: "GET" }).handler(async () => ({
  pairs: await buildPublishedComparePairs(1200),
}));

export const getPopularComparisons = createServerFn({ method: "GET" }).handler(async () => ({
  pairs: (await buildComparePairs(60)).slice(0, 24),
}));

/** Comparison links for a model hub, so compare pages get real inbound links. */
export const getModelComparisons = createServerFn({ method: "GET" })
  .inputValidator((data: { makeSlug: string; modelSlug: string }) => data)
  .handler(async ({ data }) => ({
    pairs: await findRivalsForModel(data.makeSlug, data.modelSlug, 40),
  }));
